/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a spectrophotometer reading at 260 nm into nucleic acid concentration. Enter the absorbance and dilution factor, choose the nucleic acid type, and optionally add the A280 reading to get the purity ratio.`)
};

const es_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte una lectura de espectrofotómetro a 260 nm en concentración de ácido nucleico. Introduce la absorbancia y el factor de dilución, elige el tipo de ácido nucleico y, opcionalmente, añade la lectura A280 para obtener la relación de pureza.`)
};

const de_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie eine Spektralphotometer-Messung bei 260 nm in eine Nukleinsäurekonzentration um. Geben Sie die Absorption und den Verdünnungsfaktor ein, wählen Sie den Nukleinsäuretyp und fügen Sie optional die A280-Messung hinzu, um das Reinheitsverhältnis zu erhalten.`)
};

const nl_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zet een spectrofotometermeting bij 260 nm om naar nucleïnezuurconcentratie. Vul de absorptie en verdunningsfactor in, kies het nucleïnezuurtype, en voeg optioneel de A280-meting toe om de zuiverheidsratio te krijgen.`)
};

const fr_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez une lecture de spectrophotomètre à 260 nm en concentration d'acide nucléique. Entrez l'absorbance et le facteur de dilution, choisissez le type d'acide nucléique, et ajoutez éventuellement la lecture A280 pour obtenir le ratio de pureté.`)
};

const it_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converte una lettura dello spettrofotometro a 260 nm in concentrazione di acido nucleico. Inserisci l'assorbanza e il fattore di diluizione, scegli il tipo di acido nucleico, e opzionalmente aggiungi la lettura A280 per ottenere il rapporto di purezza.`)
};

const pt_br2_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma leitura de espectrofotômetro a 260 nm em concentração de ácido nucleico. Informe a absorbância e o fator de diluição, escolha o tipo de ácido nucleico e, opcionalmente, adicione a leitura de A280 para obter a razão de pureza.`)
};

const pt_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta uma leitura de espetrofotómetro a 260 nm em concentração de ácido nucleico. Introduza a absorvância e o fator de diluição, escolha o tipo de ácido nucleico e, opcionalmente, adicione a leitura de A280 para obter o rácio de pureza.`)
};

const ja_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`260 nmでの分光光度計測定値を核酸濃度に変換します。吸光度と希釈倍率を入力し、核酸の種類を選択してください。A280の値も入力すると純度比が得られます。`)
};

const zh_od_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将分光光度计在 260 nm 处的读数转换为核酸浓度。输入吸光度和稀释倍数，选择核酸类型，也可以加入 A280 读数以获得纯度比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_intro", locale)
	if (locale === "en") return en_od_intro(inputs)
	if (locale === "es") return es_od_intro(inputs)
	if (locale === "de") return de_od_intro(inputs)
	if (locale === "nl") return nl_od_intro(inputs)
	if (locale === "fr") return fr_od_intro(inputs)
	if (locale === "it") return it_od_intro(inputs)
	if (locale === "pt-BR") return pt_br2_od_intro(inputs)
	if (locale === "pt") return pt_od_intro(inputs)
	if (locale === "ja") return ja_od_intro(inputs)
	return zh_od_intro(inputs)
};